import {
	SubscriptionStatus,
	SubscriptionType,
} from 'domain/subscription/interfaces/Subscription';

export const subscriptionCanBeEdited = (
	subscriptionStatus: SubscriptionStatus,
	subscriptionType: SubscriptionType,
	isSalesAdmin: boolean,
): boolean => {
	if (!subscriptionStatus || !subscriptionType) {
		return false;
	}

	if (subscriptionStatus === SubscriptionStatus.Canceled) {
		return false;
	}

	if (
		subscriptionStatus === SubscriptionStatus.Ordered &&
		subscriptionType === SubscriptionType.Trial
	) {
		return false;
	}

	if (isSalesAdmin && subscriptionType !== SubscriptionType.Trial) {
		return false;
	}

	return true;
};
